import { PLAN_TYPES } from "../../../models/Plan";
import SubscriptionPlansService, { IPlanSetting } from "../../../services/api/subscription-plans-service";
import { TYPE, rootContainer } from "../../../services/container/root";
import SubscriptionPlanEditorStore from "./subscription-plan-editor-store";
import SubscriptionPlanPagedListStore from "./subscription-plan-paged-list-store";

class CombinedPlansStore {
    private _settings?: IPlanSetting;

    protected get service(): SubscriptionPlansService {
		return rootContainer.get<SubscriptionPlansService>(TYPE.SubscriptionPlansService);
	}

	private _actualiseSavedPlanInCorrectStore = (plan: SubscriptionPlanEditorStore, storeType: PLAN_TYPES) => {
		if (!plan.id) {
			return;
		}
		if (!plan.is_custom && storeType === PLAN_TYPES.CUSTOM) {
			this._regularListStore.addToList(plan.getUpdatedModel());
			this._customListStore.removeFromList(plan.id);
		}

		if (plan.is_custom && storeType === PLAN_TYPES.REGULAR) {
			this._customListStore.addToList(plan.getUpdatedModel());
			this._regularListStore.removeFromList(plan.id);
		}
	}

	private _customListStore: SubscriptionPlanPagedListStore = new SubscriptionPlanPagedListStore(
		this._actualiseSavedPlanInCorrectStore,
		{ type: PLAN_TYPES.CUSTOM }
	);

	private _regularListStore: SubscriptionPlanPagedListStore = new SubscriptionPlanPagedListStore(
		this._actualiseSavedPlanInCorrectStore,
		{ type: PLAN_TYPES.REGULAR }
	);

	public getStore(type?: PLAN_TYPES): SubscriptionPlanPagedListStore {
		switch (type) {
			case PLAN_TYPES.CUSTOM:
				return this._customListStore;
			case PLAN_TYPES.REGULAR:
				return this._regularListStore;
			default:
				return this._regularListStore;
		}
	}

    public get settings(): IPlanSetting | undefined {
		return this._settings;
	}

    public async fetchSettings() {
        this._settings = await this.service.fetchSettings();
    }
}

export default new CombinedPlansStore();
